<template>
  <div class="two-box">
    <div class="two-top">
      <div class="two-top-left">
        <div>
          <h1>品牌中心</h1>
          <span>BRAND CENTER</span>
        </div>
      </div>
      <div class="two-top-right">
        <img src="../../../images/mores.png" alt="" />
        <a @click="goxq()">查看更多</a>
      </div>
    </div>
     <div class="two-bottom-center">
      <div class="two-bottom-box" v-if="brandData.length > 0">
        <div v-for="(item,index) in brandData" :key="index" @mouseenter="enterBrand(item)" @click="goBrandDetail(item.id)"  @mouseleave="leaveBrand(item)">
          <img  :src="item.logo" alt="">
          <button v-show="item.brandFlag">查看详情</button>
        </div>
      </div>
      <el-empty :image-size="200" v-else></el-empty>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentTitleIndex:true,
      brandData:[],
      brandFlag:false
    };
  },
  methods: { 
    goBrandDetail(id){
      this.$router.push({path:'/brandDeatil',query:{id}})
    },
    enterBrand(item){
       item.brandFlag = true
    },
    leaveBrand(item){
      item.brandFlag = false
    },
  },
  created() {
    this.$api.homepage.brandAll().then(res=>{
              var data = res.data
              data.forEach(item => {
                item.brandFlag = false
              })
            this.brandData = data
          })
  },
};
</script>

<style lang="less" scoped>
.two-box {
  width: 1250px;
  height: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  .two-top {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 68px;
    .two-top-left {
      display: flex;
      cursor: pointer;
      .Titleactive{
        h1{
          color: #A52A2A;
        }
       span{
         color: #A52A2A;
       }
      }
      h1 {
        font-size: 28px;
        font-weight: 700;
        text-align: left;
        color: #333333;
        line-height: 24px;
      }
      span {
        font-size: 20px;
        text-align: left;
        color: #b8b8b8;
        line-height: 41px;
      }
    }
    .two-top-right {
      a {
        font-size: 16px;
        color: #999999;
        line-height: 19px;
        margin-left: 5px;
      }
    }
  }

  .two-bottom-box{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    div{
      position: relative;
      width: 292px;
      height:120px;  
      margin: 0px 10px;
      margin-bottom: 20px;
      margin-top: 20px;
      background: #fff;
      button{
      animation: jrjc 2s;
      width: 250px;
      height:35px;
      position: absolute;
      left:50%;
      transform: translate(-50%);
      background: rgba(255,187,0,.5);
      bottom: 0;
      border:0;
      border-radius: 20px;
      color:#013972;
      font-size: 16px;
      }
      img{
        position: absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        width: 220px;
        height:80px;
        cursor: pointer;
      }
    }
  }

}
@keyframes jrjc{
  from {
      opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>